import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFincen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1871 11.9267C12.5762 11.9267 12.8915 12.2681 12.8915 12.6897C12.8915 13.111 12.5764 13.4524 12.1871 13.4524H7.77246C7.3834 13.4524 7.06807 13.111 7.06807 12.6897C7.06807 12.2681 7.3834 11.9267 7.77246 11.9267H12.1871ZM12.1871 4.78085C12.5762 4.78085 12.8915 5.12234 12.8915 5.54367C12.8915 5.96519 12.5764 6.30663 12.1871 6.30663H7.77246C7.3834 6.30663 7.06807 5.965 7.06807 5.54367C7.06807 5.12234 7.3834 4.78085 7.77246 4.78085H12.1871ZM13.8778 8.46799C14.2669 8.46799 14.5822 8.80961 14.5822 9.23094C14.5822 9.65227 14.2669 9.9939 13.8778 9.9939H7.77246C7.3834 9.9939 7.06807 9.65227 7.06807 9.23094C7.06807 8.80961 7.3834 8.46799 7.77246 8.46799H13.8778ZM17.0713 0C17.4603 0 17.7758 0.341435 17.7758 0.762955V14.5204C17.7758 16.3993 16.364 17.9279 14.6291 17.9279H3.0063C2.89103 17.9445 2.77321 17.9532 2.65339 17.9532C1.19023 17.9532 0 16.6642 0 15.0797V10.8331C0 9.24876 1.19023 7.95943 2.65339 7.95943H3.89799V0.762955C3.89799 0.341435 4.21332 0 4.60238 0H17.0713ZM3.89799 15.0797V9.4852H2.65356C1.96731 9.4852 1.40891 10.0899 1.40891 10.8331V15.0797C1.40891 15.8227 1.96714 16.4274 2.65356 16.4274V16.4021H2.89442C3.46571 16.2802 3.89799 15.7335 3.89799 15.0797ZM16.3669 14.5204V1.52577H5.3069V15.0797C5.3069 15.5563 5.19927 16.0061 5.00889 16.4021H14.6291C15.5714 16.4021 16.3669 15.5403 16.3669 14.5204Z"
	})]
});
const ForwardRef = forwardRef(SvgFincen);
export default ForwardRef;
